import api from '@/libs/axios'

export default {
  async run(payload) {
    const response = await api.post('/admin/earns/tool-utests/run', payload)
    return response.data.data || null
  },
}
